"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2774],{

/***/ 76419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable global-require */ 
const { de: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 65345:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable global-require */ 
const { en: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 88054:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(65345),
    de: __webpack_require__(76419)
};


/***/ }),

/***/ 76965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ((0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
    code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
    message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
    stack: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.arrayOf)(prop_types__WEBPACK_IMPORTED_MODULE_0__.string),
    originalError: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        name: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
        code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
        message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string
    })
}));


/***/ }),

/***/ 38209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ src_AppError; },
  "b": function() { return /* binding */ withErrorHandling; }
});

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ForceErrorHoC/index.js
var ForceErrorHoC = __webpack_require__(4354);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/i18/index.js + 16 modules
var i18 = __webpack_require__(46003);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./src/AppError/error-prop-type.js
var error_prop_type = __webpack_require__(76965);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./src/routes.js + 1 modules
var routes = __webpack_require__(72578);
;// CONCATENATED MODULE: ./src/AppError/Error400.js







const Error400 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("400");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("BAD_REQUEST")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error400 = (Error400);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/global-context/hook.js
var hook = __webpack_require__(63841);
;// CONCATENATED MODULE: ./src/utils/nav-hooks/useCurrentPath.js


/** @type {() => string} */ function useCurrentPath() {
    const context = (0,hook/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const { asPath  } = router || context;
    return asPath;
}
/* harmony default export */ var nav_hooks_useCurrentPath = (useCurrentPath);

;// CONCATENATED MODULE: ./src/AppError/Error401.js








const Error401 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("401");
    const currentPath = nav_hooks_useCurrentPath();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("NOT_AUTHORIZED")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: "".concat(routes/* default.logout */.ZP.logout, "?returnUrl=").concat(encodeURIComponent(currentPath)),
                        children: t("SIGN_IN")
                    }),
                    " ",
                    t("WITH_DIFFERENT_ACCOUNT"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error401 = (Error401);

;// CONCATENATED MODULE: ./src/AppError/Error403.js







const Error403 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("403");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("NOT_PERMITTED")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error403 = (Error403);

;// CONCATENATED MODULE: ./src/AppError/Error404.js





const Error404 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("404");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("NOT_FOUND")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: t("DESC")
            })
        ]
    });
};
/* harmony default export */ var AppError_Error404 = (Error404);

;// CONCATENATED MODULE: ./src/AppError/Error500.js







const Error500 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("500");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("SOMETHING_WENT_WRONG")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    t("DESC"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    t("PLEASE"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.support */.ZP.external.support,
                        children: t("CONTACT_US")
                    }),
                    " ",
                    t("FOR_FURTHER_ASSISTANCE"),
                    "."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error500 = (Error500);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/ContentContainer/index.js
var ContentContainer = __webpack_require__(12985);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/color.js
var color = __webpack_require__(68657);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(89032);
;// CONCATENATED MODULE: ./src/AppError/ErrorDetails.js






const ErrorDetails = (param)=>/*#__PURE__*/ {
    let { error  } = param;
    return (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
        mx: true,
        md: 10,
        lg: 8,
        center: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "panel ".concat(color/* bgColorBlack */.ZH),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: "".concat(color/* colorWhite */.A2, " px-5 py-5"),
                children: JSON.stringify(error, null, 2)
            })
        })
    });
};
ErrorDetails.propTypes = {
    error: error_prop_type/* default */.Z
};
/* harmony default export */ var AppError_ErrorDetails = (config/* publicConfig.DEBUG_MODE */.mn.DEBUG_MODE ? ErrorDetails : ()=>null);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Layout/index.js + 1 modules
var Layout = __webpack_require__(71412);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/index.js + 3 modules
var SimpleTemplate = __webpack_require__(35449);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Header/index.js + 6 modules
var Header = __webpack_require__(38529);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./src/prerendered-logo.js
var prerendered_logo = __webpack_require__(25476);
;// CONCATENATED MODULE: ./src/AppError/ErrorLayout.js









/** @type {React.FC<{ children: React.ReactNode, extra: React.ReactNode }>} */ const ErrorLayout = (param)=>/*#__PURE__*/ {
    let { children , extra  } = param;
    return (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default.Header */.Z.Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                    logo: prerendered_logo/* default */.ZP
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default.Body */.Z.Body, {
                className: color/* bgColorBlack2 */.vk,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleTemplate/* default */.Z, {
                        children: children
                    }),
                    extra && /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
                        className: "pt-9 pt-9--md pb-18 pb-18--md",
                        children: extra
                    })
                ]
            })
        ]
    });
};
ErrorLayout.propTypes = {
    children: prop_types.node,
    extra: prop_types.node
};
/* harmony default export */ var AppError_ErrorLayout = (ErrorLayout);

// EXTERNAL MODULE: ./src/AppError/mapGraphQLErrors.js
var mapGraphQLErrors = __webpack_require__(20522);
// EXTERNAL MODULE: ./locales/errors-page/index.js
var errors_page = __webpack_require__(88054);
var errors_page_default = /*#__PURE__*/__webpack_require__.n(errors_page);
;// CONCATENATED MODULE: ./src/AppError/AppError.js














const errorComponents = {
    400: AppError_Error400,
    401: AppError_Error401,
    403: AppError_Error403,
    404: AppError_Error404
};
const AppError = (param)=>{
    let { error  } = param;
    const { code  } = error;
    const ErrorComponent = errorComponents[code] || AppError_Error500;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_ErrorLayout, {
        extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_ErrorDetails, {
            error: error
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent, {
            error: error
        })
    });
};
AppError.getInitialProps = (context)=>{
    const { err , res  } = context;
    const appErr = (0,mapGraphQLErrors/* default */.ZP)(err);
    if (res) {
        res.statusCode = appErr.code;
    }
    if (appErr.code >= 500 && appErr.originalError != null) throw appErr.originalError;
    return {
        error: appErr.toSerializable()
    };
};
AppError.propTypes = {
    error: error_prop_type/* default */.Z
};
/* harmony default export */ var AppError_AppError = ((0,pipe/* default */.Z)(AppError, (0,i18/* WithLocale */._t)({
    resources: (errors_page_default())
})));

// EXTERNAL MODULE: ./node_modules/@apollo/react-hooks/lib/react-hooks.esm.js
var react_hooks_esm = __webpack_require__(18499);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ApplicationError/index.js
var ApplicationError = __webpack_require__(66651);
// EXTERNAL MODULE: ./src/graphql-local/unexpectedError/index.js + 3 modules
var unexpectedError = __webpack_require__(51041);
// EXTERNAL MODULE: ./src/sentry.js + 69 modules
var sentry = __webpack_require__(51720);
// EXTERNAL MODULE: ./src/utils/nav-hooks/useQueryString.js
var useQueryString = __webpack_require__(88046);
;// CONCATENATED MODULE: ./src/AppError/withErrorHandlingHoC.js










const withErrorHandlingHoC = (Component)=>{
    const WithErrorHandling = (param)=>{
        let { error , ...props } = param;
        const { data  } = (0,react_hooks_esm/* useQuery */.aM)(unexpectedError/* getUnexpectedError */.c);
        const asPath = nav_hooks_useCurrentPath();
        const query = (0,useQueryString/* default */.Z)();
        react.useEffect(()=>{
            if ((data === null || data === void 0 ? void 0 : data.unexpectedError) == null) return;
            (0,sentry/* notifySentry */.Yw)(ApplicationError/* default.of */.Z.of(data.unexpectedError), {
                asPath,
                query
            });
        }, [
            data === null || data === void 0 ? void 0 : data.unexpectedError
        ]);
        if (error == null && (data === null || data === void 0 ? void 0 : data.unexpectedError) == null) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                ...props
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_AppError, {
            error: error || ApplicationError/* default.of */.Z.of(data.unexpectedError)
        });
    };
    WithErrorHandling.propTypes = AppError_AppError.propTypes;
    WithErrorHandling.getInitialProps = (context)=>{
        try {
            const props = Component.getInitialProps ? Component.getInitialProps(context) : {};
            return (0,fn/* isPromise */.tI)(props) ? props.catch((err)=>AppError_AppError.getInitialProps({
                    ...context,
                    err
                })) : props;
        } catch (err) {
            return AppError_AppError.getInitialProps({
                ...context,
                err
            });
        }
    };
    return WithErrorHandling;
};
/* harmony default export */ var AppError_withErrorHandlingHoC = (withErrorHandlingHoC);

;// CONCATENATED MODULE: ./src/AppError/index.js





const withErrorHandling = (0,fn/* compose */.qC)(AppError_withErrorHandlingHoC, config/* publicConfig.DEBUG_MODE */.mn.DEBUG_MODE ? (0,ForceErrorHoC/* withForceError */.B)("throw") : fn/* idX */.Yr);
/* harmony default export */ var src_AppError = (AppError_AppError);


/***/ }),

/***/ 20522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I3": function() { return /* binding */ isNotFound; },
/* harmony export */   "_j": function() { return /* binding */ isNotAuthorized; }
/* harmony export */ });
/* unused harmony exports isGraphQLErrorIn, isBadRequest, isNotPermitted, isNetwork */
/* harmony import */ var _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66651);
/* eslint-disable no-nested-ternary, prettier/prettier */ 
const isGraphQLErrorIn = function() {
    for(var _len = arguments.length, codes = new Array(_len), _key = 0; _key < _len; _key++){
        codes[_key] = arguments[_key];
    }
    return (param)=>{
        let { graphQLErrors  } = param;
        return graphQLErrors && graphQLErrors.length && codes.includes(graphQLErrors[0].code);
    };
};
const isBadRequest = isGraphQLErrorIn(400, "INTERNAL_SERVER_ERROR");
const isNotAuthorized = isGraphQLErrorIn(401);
const isNotFound = isGraphQLErrorIn(400, 404);
const isNotPermitted = isGraphQLErrorIn(403);
const isNetwork = (param)=>{
    let { networkError  } = param;
    return networkError != null;
};
const mapGraphQLErrors = (error)=>isBadRequest(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 400) : isNotAuthorized(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 401) : isNotPermitted(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 403) : isNotFound(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error, 404) : isNetwork(error) ? new _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(error) : _insightfulscience_smart_react_ApplicationError__WEBPACK_IMPORTED_MODULE_0__/* ["default"].of */ .Z.of(error);
/* harmony default export */ __webpack_exports__["ZP"] = (mapGraphQLErrors);


/***/ }),

/***/ 96778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ readOrderData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4969);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	query getOrderByID($orderNumber: Int!) {\n		getOrderByID(orderNumber: $orderNumber) {\n			orderNumber\n			firstName\n			lastName\n			company\n			address1\n			address2\n			address3\n			city\n			state\n			phone\n			zip\n			country {\n				name\n			}\n			invoiceNumber\n			orderDate\n			status\n			totalCharged\n			platformTypes\n			salesTaxRate\n			balance\n			salesTaxAmount\n			isSerialNumberGenerationPending\n			orderDetails {\n				orderDetailID\n				qty\n				description\n				activations\n				unitPrice\n				plan {\n					name\n				}\n				product {\n					name\n				}\n			}\n			subscription {\n				allowedActivations\n				subscriptionID\n				name\n				serialNumbers {\n					serialNumber\n					licenseName\n					allowedActivations\n					usedActivations\n					product {\n						description\n					}\n					code\n				}\n				allowedOperations {\n					viewInvoice\n				}\n			}\n			serialNumbers {\n				serialNumber\n				licenseName\n				allowedActivations\n				usedActivations\n				product {\n					description\n				}\n				code\n			}\n			payments {\n				id\n				amount\n				paymentType {\n					paymentTypeID\n					name\n				}\n				ccNumber\n				ccType\n			}\n		}\n	}\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject()));
const readOrderData = (param)=>{
    let { data  } = param;
    return data && data.getOrderByID;
};


/***/ }),

/***/ 69100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ readSubscriptionData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4969);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	query getSubscriptionByID($subscriptionID: Int!) {\n		getSubscriptionByID(subscriptionID: $subscriptionID) {\n			subscriptionID\n			dateCreated\n			expirationDate\n			status\n			archiveBit\n			allowedActivations\n			isAutoBillingEnabled\n			isTrial\n			customer {\n				email\n			}\n			serialNumbers {\n				licenseName\n				serialNumber\n				usedActivations\n				activations {\n					id\n					email\n					status\n					version\n					activated\n					deactivated\n					computerName\n				}\n				downloads {\n					id\n					os\n					release\n					releaseDate\n					architectures\n					minOSVersion\n					minOSName\n					downloadLink\n				}\n			}\n			billingName\n			billingEmail\n			billingCompany\n			billingDepartment\n			billingAddress1\n			billingAddress2\n			billingCity\n			billingState\n			billingZipCode\n			billingCountryID\n			billingCountry {\n				name\n			}\n			billingPhoneNumber\n			plan {\n				name\n				planCode\n			}\n			adminEmails {\n				id\n				adminEmail\n			}\n			orders {\n				orderNumber\n				status\n				createdBy\n			}\n			lastOrder {\n				orderNumber\n				isSerialNumberGenerationPending\n			}\n			allowedOperations {\n				addons\n				renewal\n			}\n		}\n	}\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject()));
const readSubscriptionData = (param)=>{
    let { data  } = param;
    return data && data.getSubscriptionByID;
};


/***/ }),

/***/ 9724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4969);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	query getSubscriptionWithAddonPrices($subscriptionID: Int!) {\n		getSubscriptionByID(subscriptionID: $subscriptionID) {\n			subscriptionID\n			dateCreated\n			expirationDate\n			allowedActivations\n			isAutoBillingEnabled\n			billingName\n			billingEmail\n			billingCompany\n			billingDepartment\n			billingAddress1\n			billingAddress2\n			billingCity\n			billingState\n			billingZipCode\n			billingCountryID\n			billingPhoneNumber\n			status\n			isTrial\n			customer {\n				email\n			}\n			serialNumbers {\n				licenseName\n				serialNumber\n				usedActivations\n				activations {\n					id\n					status\n					version\n					activated\n					deactivated\n					computerName\n				}\n			}\n			plan {\n				name\n				planCode\n			}\n			addonPrices {\n				renewalPlan {\n					name\n					planCode\n				}\n				newPlanCode\n				newSeats\n				renewalPrice\n				price\n				subscriptionSize\n				betterOption\n			}\n			orders {\n				orderNumber\n				status\n				createdBy\n			}\n			allowedOperations {\n				addons\n			}\n		}\n	}\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject()));


/***/ }),

/***/ 31817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4969);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	query getSubscriptionWithRenewPrices($subscriptionID: Int!) {\n		getSubscriptionByID(subscriptionID: $subscriptionID) {\n			subscriptionID\n			dateCreated\n			expirationDate\n			allowedActivations\n			isAutoBillingEnabled\n			billingName\n			billingEmail\n			billingCompany\n			billingDepartment\n			billingAddress1\n			billingAddress2\n			billingCity\n			billingState\n			billingZipCode\n			billingCountryID\n			billingPhoneNumber\n			isTrial\n			customer {\n				email\n			}\n			serialNumbers {\n				licenseName\n				serialNumber\n				usedActivations\n				activations {\n					id\n					status\n					version\n					activated\n					deactivated\n					computerName\n				}\n			}\n			plan {\n				name\n				planCode\n			}\n			renewPrices {\n				newPlanCode\n				newSeats\n				price\n				subscriptionSize\n				betterOption\n			}\n			allowedOperations {\n				renewal\n			}\n		}\n	}\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject()));


/***/ }),

/***/ 33620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c8": function() { return /* binding */ cancelSubscriptionWithSurvey; },
  "ZP": function() { return /* binding */ ecommerce; },
  "PS": function() { return /* reexport */ subscriptionFlags/* getSubscriptionFlags */.PS; },
  "UY": function() { return /* binding */ isSnSuccessfull; },
  "FD": function() { return /* binding */ licensesResolvers; },
  "MH": function() { return /* binding */ planToUpdate; },
  "e_": function() { return /* binding */ ecommerce_purchase; },
  "Go": function() { return /* binding */ reactivateSubscription; },
  "TV": function() { return /* binding */ updatePaymentMethod; },
  "uk": function() { return /* binding */ updateSubscriptionByID; }
});

// UNUSED EXPORTS: addActivationToBlackList, cancelSubscription, getRenewableSubscriptions, getSubscriptionsList, removeActivationFromBlackList

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
;// CONCATENATED MODULE: ./config/serialNumbers.json
var serialNumbers_namespaceObject = JSON.parse('{"j":"REGCODE_CREATION_FAILED","h":"REGCODE_UPDATE_FAILED"}');
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 15 modules
var lib = __webpack_require__(4969);
;// CONCATENATED MODULE: ./src/graphql/queries/getCart.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	query getCart($billingInfo: BillingInfoInput!, $cartItems: [CartItemInput!]!) {\n		getCart(billingInfo: $billingInfo, cartItems: $cartItems) {\n			cartItems {\n				platform\n				subscriptionSize\n				price\n				newSeats\n				billingPeriod\n				expirationDate\n				name\n				subscriptionRenewPrice\n				purchaseType\n			}\n			cartAsJSON\n		}\n	}\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var getCart = ((0,lib/* default */.ZP)(_templateObject()));
const readCart = (param)=>{
    let { data  } = param;
    return data && data.getCart;
};

// EXTERNAL MODULE: ./src/utils/nextSignleton/index.js + 2 modules
var nextSignleton = __webpack_require__(74733);
// EXTERNAL MODULE: ./src/apollo/index.js + 14 modules
var apollo = __webpack_require__(75469);
;// CONCATENATED MODULE: ./src/graphql/queries/getPlanWithPrices.js

function getPlanWithPrices_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	query getPlan($planCode: String!) {\n		getPlanWithPrices(planCode: $planCode) {\n			planID\n			name\n			prices {\n				planCode\n				subscriptionSize\n				price\n				betterOption\n			}\n		}\n	}\n"
    ]);
    getPlanWithPrices_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var getPlanWithPrices = ((0,lib/* default */.ZP)(getPlanWithPrices_templateObject()));
const readPlan = (param)=>{
    let { data  } = param;
    return data && data.getPlanWithPrices;
};
const readPrices = (plan)=>plan && plan.prices;
const packPlanCode = (planCode)=>({
        planCode
    });

;// CONCATENATED MODULE: ./src/graphql/mutations/purchase.js

function purchase_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	mutation purchase($purchaseInput: PurchaseInput!) {\n		purchase(purchaseInput: $purchaseInput) {\n			orderNumber\n			paymentID\n			order {\n				subscriptionID\n				subscription {\n					isFromTrial\n					plan {\n						planCode\n					}\n				}\n			}\n		}\n	}\n"
    ]);
    purchase_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var purchase = ((0,lib/* default */.ZP)(purchase_templateObject()));
const readPaymentResult = (param)=>{
    let { data  } = param;
    return data && {
        ...data.purchase
    };
};

;// CONCATENATED MODULE: ./src/graphql/mutations/subscriptionPurchaseActivations.js

function subscriptionPurchaseActivations_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	mutation updateSubscriptionByIDV2($subscriptionID: Int!, $newSeats: Int!) {\n		updateSubscriptionByIDV2(subscriptionID: $subscriptionID, newSeats: $newSeats) {\n			... on Order {\n				orderNumber\n				totalAmount\n			}\n\n			... on UpdateSubscriptionByIDFailure {\n				errorCode\n				message\n			}\n		}\n	}\n"
    ]);
    subscriptionPurchaseActivations_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var subscriptionPurchaseActivations = ((0,lib/* default */.ZP)(subscriptionPurchaseActivations_templateObject()));
const readUpdateSubscriptionResult = (param)=>{
    let { data  } = param;
    return data && {
        ...data.updateSubscriptionByIDV2
    };
};

;// CONCATENATED MODULE: ./src/graphql/mutations/updatePaymentMethodMutation.js

function updatePaymentMethodMutation_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	mutation updatePaymentMethod($subscriptionID: ID!, $token: String!) {\n		updatePaymentMethod(subscriptionID: $subscriptionID, token: $token)\n	}\n"
    ]);
    updatePaymentMethodMutation_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var updatePaymentMethodMutation = ((0,lib/* default */.ZP)(updatePaymentMethodMutation_templateObject()));

// EXTERNAL MODULE: ./src/graphql/queries/getSubscriptionByID.js
var getSubscriptionByID = __webpack_require__(69100);
// EXTERNAL MODULE: ./src/graphql/queries/getPerpetuals.js
var getPerpetuals = __webpack_require__(35020);
;// CONCATENATED MODULE: ./src/graphql/queries/getPerpetual.js

function getPerpetual_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	query getPerpetual($id: Int!) {\n		getPerpetual(id: $id) {\n			serialNumber\n			dateCreated\n			licenseName\n			allowedActivations\n			usedActivations\n			product {\n				description\n			}\n			activations {\n				id\n				status\n				version\n				activated\n				deactivated\n				computerName\n			}\n			downloads {\n				id\n				os\n				release\n				releaseDate\n				architectures\n				minOSVersion\n				minOSName\n				downloadLink\n			}\n		}\n	}\n"
    ]);
    getPerpetual_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var getPerpetual = ((0,lib/* default */.ZP)(getPerpetual_templateObject()));
const readDataFromPerpetual = (param)=>{
    let { data  } = param;
    return data.getPerpetual;
};

// EXTERNAL MODULE: ./src/graphql/queries/getSubscriptionsList.js
var getSubscriptionsList = __webpack_require__(94988);
;// CONCATENATED MODULE: ./src/graphql/queries/getRenewableSubscriptions.js

function getRenewableSubscriptions_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	query getRenewableSubscriptions {\n		getRenewableSubscriptions {\n			subscriptionID\n			name\n			expirationDate\n			isTrial\n		}\n	}\n"
    ]);
    getRenewableSubscriptions_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var getRenewableSubscriptions = ((0,lib/* default */.ZP)(getRenewableSubscriptions_templateObject()));
const readRenewableSubscriptions = (param)=>{
    let { data  } = param;
    return data && data.getRenewableSubscriptions;
};

// EXTERNAL MODULE: ./src/graphql/queries/getOrderByID.js
var getOrderByID = __webpack_require__(96778);
;// CONCATENATED MODULE: ./src/graphql/mutations/removeActivationFromBlackList.js

function removeActivationFromBlackList_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	mutation removeActivationFromBlackList($serialNumber: String!, $uuid: String!) {\n		removeActivationFromBlackList(serialNumber: $serialNumber, uuid: $uuid)\n	}\n"
    ]);
    removeActivationFromBlackList_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var removeActivationFromBlackList = ((0,lib/* default */.ZP)(removeActivationFromBlackList_templateObject()));

;// CONCATENATED MODULE: ./src/graphql/mutations/addActivationToBlackList.js

function addActivationToBlackList_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	mutation addActivationToBlackList($serialNumber: String!, $uuid: String!) {\n		addActivationToBlackList(serialNumber: $serialNumber, uuid: $uuid)\n	}\n"
    ]);
    addActivationToBlackList_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var addActivationToBlackList = ((0,lib/* default */.ZP)(addActivationToBlackList_templateObject()));

;// CONCATENATED MODULE: ./src/graphql/mutations/cancelSubscriptionMutation.js

function cancelSubscriptionMutation_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	mutation cancelSubscription($subscriptionID: Int!) {\n		cancelSubscriptionByID(subscriptionID: $subscriptionID)\n	}\n"
    ]);
    cancelSubscriptionMutation_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var mutations_cancelSubscriptionMutation = ((0,lib/* default */.ZP)(cancelSubscriptionMutation_templateObject()));

;// CONCATENATED MODULE: ./src/graphql/mutations/cancelSubscriptionWithSurveyMutation.js

function cancelSubscriptionWithSurveyMutation_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	mutation cancelSubscriptionByIDV2(\n		$subscriptionId: Int!\n		$cancellationSurvey: CancellationSurveyInput!\n	) {\n		cancelSubscriptionByIDV2(\n			subscriptionID: $subscriptionId\n			cancellationSurvey: $cancellationSurvey\n		) {\n			... on CancelSubscriptionByIDSuccess {\n				result\n			}\n\n			... on CancelSubscriptionByIDFailure {\n				errorCode\n				message\n			}\n		}\n	}\n"
    ]);
    cancelSubscriptionWithSurveyMutation_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var cancelSubscriptionWithSurveyMutation = ((0,lib/* default */.ZP)(cancelSubscriptionWithSurveyMutation_templateObject()));
const readCancelSubscriptionByIDV2Result = (param)=>{
    let { data  } = param;
    return data && {
        ...data.cancelSubscriptionByIDV2
    };
};

;// CONCATENATED MODULE: ./src/graphql/mutations/reactivateSubscriptionMutation.js

function reactivateSubscriptionMutation_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	mutation reactivateSubscriptionByIDV2($subscriptionID: Int!) {\n		reactivateSubscriptionByIDV2(subscriptionID: $subscriptionID) {\n			... on ReactivateSubscriptionByIDSuccess {\n				result\n			}\n\n			... on ReactivateSubscriptionByIDFailure {\n				errorCode\n				message\n			}\n		}\n	}\n"
    ]);
    reactivateSubscriptionMutation_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var reactivateSubscriptionMutation = ((0,lib/* default */.ZP)(reactivateSubscriptionMutation_templateObject()));
const readReactivateSubscriptionByIDV2Result = (param)=>{
    let { data  } = param;
    return data && {
        ...data.reactivateSubscriptionByIDV2
    };
};

// EXTERNAL MODULE: ./src/graphql/queries/getSubscriptionWithRenewPrices.js
var getSubscriptionWithRenewPrices = __webpack_require__(31817);
// EXTERNAL MODULE: ./src/graphql/queries/getSubscriptionWithAddonPrices.js
var getSubscriptionWithAddonPrices = __webpack_require__(9724);
;// CONCATENATED MODULE: ./src/graphql/queries/SubscriptionWithPaymentMethod.js

function SubscriptionWithPaymentMethod_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	query SubscriptionWithPaymentMethod($subscriptionID: Int!) {\n		getSubscriptionByID(subscriptionID: $subscriptionID) {\n			subscriptionID\n			dateCreated\n			expirationDate\n			status\n			archiveBit\n			allowedActivations\n			isTrial\n			isAutoBillingEnabled\n			customer {\n				email\n			}\n			serialNumbers {\n				code\n				licenseName\n				serialNumber\n				usedActivations\n				activations {\n					id\n				}\n			}\n			paymentInfo {\n				firstName\n				lastName\n				cardType\n				lastFour\n				expYear\n				expMonth\n				cardType\n			}\n			billingName\n			billingEmail\n			billingCompany\n			billingDepartment\n			billingAddress1\n			billingAddress2\n			billingCity\n			billingState\n			billingZipCode\n			billingCountryID\n			billingCountry {\n				name\n			}\n			paymentMethod {\n				address1\n				address2\n				address3\n				phone\n				city\n				state\n				email\n				zipCode\n				countryID\n				country {\n					name\n					isoAlpha2\n				}\n				company\n				firstName\n				lastName\n			}\n			billingPhoneNumber\n			plan {\n				name\n				planCode\n			}\n			renewalPlan {\n				name\n			}\n			orders {\n				orderNumber\n				invoiceNumber\n				status\n				totalAmount\n				orderDate\n				createdBy\n				orderCategoryID\n			}\n			allowedOperations {\n				addons\n				viewInvoice\n			}\n		}\n	}\n"
    ]);
    SubscriptionWithPaymentMethod_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var SubscriptionWithPaymentMethod = ((0,lib/* default */.ZP)(SubscriptionWithPaymentMethod_templateObject()));
const readSubscriptionData = (param)=>{
    let { data  } = param;
    return data && data.getSubscriptionByID;
};

;// CONCATENATED MODULE: ./src/graphql/queries/getThreePlanPrices.js

function getThreePlanPrices_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\n	fragment PlanDetails on PlanWithPrices {\n		planCode\n		name\n		prices {\n			subscriptionSize\n			price\n			betterOption\n		}\n	}\n\n	query getThreePlanPrices {\n		studentPlan: getPlanWithPrices(planCode: "sg_student_yearly", maxSeats: 1) {\n			...PlanDetails\n		}\n		academicPlan: getPlanWithPrices(planCode: "sg_academic_yearly") {\n			...PlanDetails\n		}\n		corporatePlan: getPlanWithPrices(planCode: "sg_corporate_yearly") {\n			...PlanDetails\n		}\n	}\n'
    ]);
    getThreePlanPrices_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var getThreePlanPrices = ((0,lib/* default */.ZP)(getThreePlanPrices_templateObject()));
const readThreePlanPrices = (param)=>{
    let { data  } = param;
    return data;
};

// EXTERNAL MODULE: ./src/services/subscriptionFlags.js
var subscriptionFlags = __webpack_require__(14387);
;// CONCATENATED MODULE: ./src/services/ecommerce.js

























const getPrices = (context)=>(planCode)=>(0,apollo/* default */.Z)(context).query({
            query: getPlanWithPrices,
            variables: packPlanCode(planCode)
        }).then((0,fn/* compose */.qC)(readPrices, readPlan));
const ecommerce_getCart = (context)=>(selectedItem, billingInfo)=>(0,apollo/* default */.Z)(context).query({
            query: getCart,
            variables: {
                cartItems: [
                    {
                        planCode: selectedItem.planCode,
                        subscriptionSize: selectedItem.seats,
                        licenseName: billingInfo.labName,
                        newSeats: selectedItem.seats,
                        subscriptionID: selectedItem.subscriptionID,
                        purchaseType: selectedItem.purchaseType
                    }
                ],
                billingInfo: {
                    email: billingInfo.email,
                    firstName: billingInfo.firstName,
                    lastName: billingInfo.lastName,
                    company: billingInfo.company,
                    labName: billingInfo.labName,
                    countryID: billingInfo.countryID,
                    state: billingInfo.state,
                    city: billingInfo.city,
                    address1: billingInfo.address1,
                    address2: billingInfo.address2,
                    address3: billingInfo.address3,
                    zipCode: billingInfo.zipCode,
                    phone: billingInfo.phone
                }
            }
        }).then(readCart);
const getSubscriptionById = (context)=>function(subscriptionId) {
        let subscriptionQuery = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getSubscriptionByID/* default */.Z;
        return (0,apollo/* default */.Z)(context).query({
            query: subscriptionQuery,
            variables: {
                subscriptionID: parseInt(subscriptionId, 10)
            }
        }).then(getSubscriptionByID/* readSubscriptionData */.$);
    };
const subscriptionWithPaymentMethod = (context)=>function(subscriptionId) {
        let subscriptionQuery = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : SubscriptionWithPaymentMethod;
        return (0,apollo/* default */.Z)(context).query({
            query: subscriptionQuery,
            variables: {
                subscriptionID: parseInt(subscriptionId, 10)
            }
        }).then(getSubscriptionByID/* readSubscriptionData */.$);
    };
const planToUpdate = (planCode)=>planCode && planCode.replace(/_student_/, "_academic_");
const getSubscriptionWithPlanPrices = (context)=>{
    const getSubscription = getSubscriptionById(context);
    return (subscriptionId, purchaseType)=>getSubscription(subscriptionId, purchaseType === "renew" // checking purchaseType
         ? getSubscriptionWithRenewPrices/* default */.Z : getSubscriptionWithAddonPrices/* default */.Z);
};
const getOrderById = (context)=>(orderNumber)=>{
        return (0,apollo/* default */.Z)(context).query({
            query: getOrderByID/* default */.Z,
            variables: {
                orderNumber: parseInt(orderNumber, 10)
            }
        }).then(getOrderByID/* readOrderData */.b);
    };
const getPerpetualById = (context)=>(id)=>(0,apollo/* default */.Z)(context).query({
            query: getPerpetual,
            variables: {
                id: parseInt(id, 10)
            }
        }).then(readDataFromPerpetual);
const ecommerce_getSubscriptionsList = (context)=>()=>(0,apollo/* default */.Z)(context).query({
            query: getSubscriptionsList/* default */.ZP
        }).then(getSubscriptionsList/* readSubscriptions */.OU);
const getPerpetualsList = (context)=>()=>(0,apollo/* default */.Z)(context).query({
            query: getPerpetuals/* default */.Z
        }).then(getPerpetuals/* readPerpetuals */.b);
const ecommerce_getRenewableSubscriptions = (context)=>()=>(0,apollo/* default */.Z)(context).query({
            query: getRenewableSubscriptions
        }).then(readRenewableSubscriptions);
const ecommerce_getThreePlanPrices = (context)=>()=>(0,apollo/* default */.Z)(context).query({
            query: getThreePlanPrices
        }).then(readThreePlanPrices);
const ecommerce_addActivationToBlackList = (context)=>(serialNumber, uuid)=>(0,apollo/* default */.Z)(context).mutate({
            mutation: addActivationToBlackList,
            variables: {
                serialNumber,
                uuid
            }
        }).then(()=>true);
const ecommerce_removeActivationFromBlackList = (context)=>(serialNumber, uuid)=>(0,apollo/* default */.Z)(context).mutate({
            mutation: removeActivationFromBlackList,
            variables: {
                serialNumber,
                uuid
            }
        }).then(()=>true);
const eCommerce = (0,nextSignleton/* default */.Z)((context)=>({
        getPrices: getPrices(context),
        getSubscriptionByID: getSubscriptionById(context),
        getSubscriptionWithPaymentMethod: subscriptionWithPaymentMethod(context),
        getSubscriptionWithPlanPrices: getSubscriptionWithPlanPrices(context),
        getOrderByID: getOrderById(context),
        getPerpetualById: getPerpetualById(context),
        getSubscriptionsList: ecommerce_getSubscriptionsList(context),
        getPerpetualsList: getPerpetualsList(context),
        getCart: ecommerce_getCart(context),
        getRenewableSubscriptions: ecommerce_getRenewableSubscriptions(context),
        getThreePlanPrices: ecommerce_getThreePlanPrices(context),
        addActivationToBlackList: ecommerce_addActivationToBlackList(context),
        removeActivationFromBlackList: ecommerce_removeActivationFromBlackList(context)
    }));
const ecommerce_purchase = (param)=>{
    let { token , paymentType , cartAsJSON , licenseName  } = param;
    return (0,apollo/* default */.Z)().mutate({
        mutation: purchase,
        variables: {
            purchaseInput: {
                token,
                paymentType,
                cartAsJSON,
                licenseName
            }
        }
    }).then(readPaymentResult);
};
const updatePaymentMethod = (subscriptionID, token)=>(0,apollo/* default */.Z)().mutate({
        mutation: updatePaymentMethodMutation,
        variables: {
            subscriptionID,
            token
        }
    }).then(()=>true);
const updateSubscriptionByID = (param, newSeats)=>{
    let { subscriptionID , planCode  } = param;
    return (0,apollo/* default */.Z)().mutate({
        mutation: subscriptionPurchaseActivations,
        variables: {
            subscriptionID,
            newSeats,
            planCode
        }
    }).then(readUpdateSubscriptionResult);
};
const cancelSubscription = (param)=>{
    let { subscriptionID , planCode  } = param;
    return apolloClient().mutate({
        mutation: cancelSubscriptionMutation,
        variables: {
            subscriptionID,
            planCode
        }
    }).then(()=>true);
};
const cancelSubscriptionWithSurvey = (param)=>{
    let { subscriptionId , cancellationSurvey , planCode  } = param;
    return (0,apollo/* default */.Z)().mutate({
        mutation: cancelSubscriptionWithSurveyMutation,
        variables: {
            subscriptionId,
            cancellationSurvey,
            planCode
        }
    }).then(readCancelSubscriptionByIDV2Result);
};
const reactivateSubscription = (param)=>{
    let { subscriptionID , planCode  } = param;
    return (0,apollo/* default */.Z)().mutate({
        mutation: reactivateSubscriptionMutation,
        variables: {
            subscriptionID,
            planCode
        }
    }).then(readReactivateSubscriptionByIDV2Result);
};
const licensesResolvers = {
    subscriptions: (context)=>eCommerce(context).getSubscriptionsList(),
    perpetuals: (context)=>eCommerce(context).getPerpetualsList()
};
/** @type {(serialNumber: { code: string }) => boolean} */ const isSnSuccessfull = function() {
    let { code  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return code !== serialNumbers_namespaceObject.h && code !== serialNumbers_namespaceObject.j;
};
/* harmony default export */ var ecommerce = (eCommerce);


/***/ }),

/***/ 14387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PI": function() { return /* binding */ isAllowedBuyAddons; },
/* harmony export */   "PS": function() { return /* binding */ getSubscriptionFlags; },
/* harmony export */   "Qe": function() { return /* binding */ isAutoBillingSubscription; },
/* harmony export */   "Z1": function() { return /* binding */ isSubscriptionExpired; },
/* harmony export */   "bg": function() { return /* binding */ isAllowedViewInvoice; },
/* harmony export */   "gd": function() { return /* binding */ isSubscriptionCancelled; },
/* harmony export */   "hz": function() { return /* binding */ hasSusbscriptionDunning; },
/* harmony export */   "lM": function() { return /* binding */ isAllowedRenewal; },
/* harmony export */   "xC": function() { return /* binding */ isSubscriptionActive; }
/* harmony export */ });
/* unused harmony exports isSubscriptionReturned, isSubscriptionNonAutoRenewal, isSubscriptionFloating, isSubscriptionNetwork, isSubscriptionServer, isSubscriptionPerpetual, isHasPaymentMethod, isSerialNumberGenerationPending */
/* harmony import */ var _insightfulscience_shared_utils_dates_dateDiff__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81465);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89032);


const { nonAutoRenewal  } = _config__WEBPACK_IMPORTED_MODULE_0__/* .publicConfig.PLANS */ .mn.PLANS;
const RENEWAL_ENABLED_DAYS = 60;
const PLAN_FLOATING_CRITERIA = "_floating_";
const PLAN_NETWORK_CRITERIA = "_network_";
const PLAN_SERVER_CRITERIA = "_server_";
const SUBSCRIPTION_STATUS = {
    ACTIVE: "active",
    CANCELLED: "cancelled",
    EXPIRED: "expired"
};
const ORDER_STATUS = {
    PENDING: "pending",
    CANCELLED: "cancelled"
};
const isSubscriptionExpired = (param)=>{
    let { isAutoBillingEnabled , expirationDate , status  } = param;
    const now = new Date();
    return isAutoBillingEnabled ? status === SUBSCRIPTION_STATUS.EXPIRED : (0,_insightfulscience_shared_utils_dates_dateDiff__WEBPACK_IMPORTED_MODULE_1__/* .diffDays */ .M)(now, new Date(expirationDate)) < 0 || status === SUBSCRIPTION_STATUS.EXPIRED;
};
const isSubscriptionCancelled = (subscription)=>subscription.status === SUBSCRIPTION_STATUS.CANCELLED;
const isSubscriptionActive = (subscription)=>subscription.status === SUBSCRIPTION_STATUS.ACTIVE;
const isSubscriptionReturned = (subscription)=>subscription.status === SUBSCRIPTION_STATUS.EXPIRED && subscription.archiveBit;
const isSubscriptionNonAutoRenewal = (subscription)=>{
    var ref;
    return nonAutoRenewal.includes((ref = subscription.plan) === null || ref === void 0 ? void 0 : ref.planCode);
};
const isSubscriptionFloating = (subscription)=>{
    var ref, ref1;
    return !!((ref = subscription.plan) === null || ref === void 0 ? void 0 : (ref1 = ref.planCode) === null || ref1 === void 0 ? void 0 : ref1.includes(PLAN_FLOATING_CRITERIA));
};
const isSubscriptionNetwork = (subscription)=>{
    var ref, ref1;
    return !!((ref = subscription.plan) === null || ref === void 0 ? void 0 : (ref1 = ref.planCode) === null || ref1 === void 0 ? void 0 : ref1.includes(PLAN_NETWORK_CRITERIA));
};
const isSubscriptionServer = (subscription)=>{
    var ref, ref1;
    return !!((ref = subscription.plan) === null || ref === void 0 ? void 0 : (ref1 = ref.planCode) === null || ref1 === void 0 ? void 0 : ref1.includes(PLAN_SERVER_CRITERIA));
};
const isSubscriptionPerpetual = (subscription)=>subscription.expirationDate == null;
const isAutoBillingSubscription = (subscription)=>subscription.isAutoBillingEnabled;
const isHasPaymentMethod = (subscription)=>subscription.paymentInfo !== null;
const hasSusbscriptionDunning = (subscription)=>Array.isArray(subscription.orders) && subscription.orders.some((param)=>{
        let { status , createdBy  } = param;
        return status === ORDER_STATUS.PENDING && createdBy === "webhook";
    });
const isSerialNumberGenerationPending = (subscription)=>{
    var ref;
    return subscription === null || subscription === void 0 ? void 0 : (ref = subscription.lastOrder) === null || ref === void 0 ? void 0 : ref.isSerialNumberGenerationPending;
};
const isAllowedBuyAddons = (subscription)=>{
    var ref;
    return subscription === null || subscription === void 0 ? void 0 : (ref = subscription.allowedOperations) === null || ref === void 0 ? void 0 : ref.addons;
};
const isAllowedViewInvoice = (subscription)=>{
    var ref;
    return subscription === null || subscription === void 0 ? void 0 : (ref = subscription.allowedOperations) === null || ref === void 0 ? void 0 : ref.viewInvoice;
};
const isAllowedRenewal = (subscription)=>{
    var ref;
    return subscription === null || subscription === void 0 ? void 0 : (ref = subscription.allowedOperations) === null || ref === void 0 ? void 0 : ref.renewal;
};
const getSubscriptionFlags = (subscription)=>{
    const now = new Date();
    const hasDunning = hasSusbscriptionDunning(subscription);
    const isExpired = isSubscriptionExpired(subscription);
    const isCancelled = isSubscriptionCancelled(subscription);
    const isActive = isSubscriptionActive(subscription);
    const isReturned = isSubscriptionReturned(subscription);
    const isNonAutoRenewal = isSubscriptionNonAutoRenewal(subscription);
    const isFloating = isSubscriptionFloating(subscription);
    const isNetwork = isSubscriptionNetwork(subscription);
    const isServer = isSubscriptionServer(subscription);
    const isPerpetual = isSubscriptionPerpetual(subscription);
    const isAutoBillingEnabled = isAutoBillingSubscription(subscription);
    const isRenewalEnabled = !isAutoBillingEnabled && (0,_insightfulscience_shared_utils_dates_dateDiff__WEBPACK_IMPORTED_MODULE_1__/* .diffDays */ .M)(now, new Date(subscription.expirationDate)) <= RENEWAL_ENABLED_DAYS;
    const statusEventName = isPerpetual && "PURCHASED" || isExpired && "EXPIRED" || isAutoBillingEnabled && isActive && "RENEWS" || "EXPIRES";
    const isSerialNumberGenerationFailed = isSerialNumberGenerationPending(subscription);
    const hasPaymentMethod = isHasPaymentMethod(subscription);
    const isBuyAddonEnabled = isAllowedBuyAddons(subscription);
    const isViewInvoiceEnabled = isAllowedViewInvoice(subscription);
    const isRenewalButtonEnabled = isAllowedRenewal(subscription);
    return {
        isRenewalEnabled,
        isExpired,
        isCancelled,
        isActive,
        isReturned,
        isNonAutoRenewal,
        isFloating,
        isNetwork,
        isPerpetual,
        hasDunning,
        isAutoBillingEnabled,
        statusEventName,
        isServer,
        isSerialNumberGenerationFailed,
        hasPaymentMethod,
        isBuyAddonEnabled,
        isViewInvoiceEnabled,
        isRenewalButtonEnabled
    };
};


/***/ }),

/***/ 88046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _insightfulscience_smart_react_url_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89333);
/* harmony import */ var _global_context_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63841);




function useQueryString() {
    const context = (0,_global_context_hook__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { asPath  } = router || context;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>(0,_insightfulscience_smart_react_url_query__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(asPath), [
        asPath
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useQueryString);


/***/ })

}]);